import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { User, UsersSlice } from './types';
import { getUsers } from '../../api/user';

const initialState: UsersSlice[] = [];

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    loadUsers: (state, action: PayloadAction<UsersSlice[]>) => {
      return action.payload;
    }
  }
});

export const { loadUsers } = usersSlice.actions;

export const selectUsers = (state: RootState) => {
  return state.users;
};

export const fetchUsers = (): AppThunk => async (dispatch, getState) => {
  const { user } = getState();
  console.log('getting users')
  try {
    // Call GET request to get user details
    const users = await getUsers(user.api_key, user.account.id); 
    
    // Format the users details
    var ProcessedUsers: Array<UsersSlice> = users.map((user: User) => prepareUser(user));
        
    // Dispatch users to the reducer
    dispatch(loadUsers(ProcessedUsers));
    
  } catch (err) {
    console.error(err.toString());
  }
};

/**
 * Converts API response for user object to the app's format.
 */
 const prepareUser = (user : User) : UsersSlice => {
  return {
      id: user.id,
      account_id: user.account_id,                        
      user_name: user.user_name,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
  }
}

export default usersSlice.reducer;
